<template>
  <v-card>
    <v-dialog scrollable v-model="loading" persistent max-width="200">
      <v-card>
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-card-text>
      <pbas-data-table
        ref="table"
        :dataProvider="provider"
        @itemsChanged="setData($event)"
        :identifier="`contributionsControlEmployers${employer.Id}`"
        @error="error = $event"
        @items-change-warning="itemsChangeWarning($event)"
        :itemsChangeWarning="true"
        :showSelect="false"
        v-if="provider !== null && provider !== undefined"
        :floatActions="floatActions"
        :sortBy="'StartDate'"
        :sortDescending="true"
        :rowActions="rowActions"
      >
        <template
          v-for="(header, index) in provider.headers"
          v-slot:[itemSlotFunc(header)]="{ header, item }"
        >
          <div v-bind:key="header.type.key" v-if="header.type.key === 'Id'">
            <v-btn small text @click.prevent="rowActions[0].handler(item)">
              <v-icon>
                {{ rowActions[0].icon }}
              </v-icon>
              {{ $t(rowActions[0].title) }}
            </v-btn>
            <v-icon v-if="!item.modified">check</v-icon>
          </div>
          <v-tooltip
            top
            v-bind:key="header.type.key"
            v-if="header.type.key === 'Name'"
          >
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <no-autocomplete-textfield
                  style="min-width: 200px"
                  label=" "
                  :value="item.Name"
                  @input="updateName($event, item)"
                  :rules="[
                    $rules.required,
                    $rules.numericString,
                    $rules.dynamic.length(2),
                  ]"
                  class="required"
                ></no-autocomplete-textfield>
                <!-- <trans-textbox
                  style="min-width: 200px"
                  label=" " 
                  :value="item"
                  field="Name"
                  @change="updateName($event, item)"
                  :rules="[$rules.required]"
                  class="required"
                  type="number"
                ></trans-textbox> -->
              </div>
            </template>
            <span class="previous-value-tooltip">
              {{ $t("components.memberimportsalaries.previous_value") }}
              <b>{{ displayOriginalName(item) }}</b>
            </span>
          </v-tooltip>
          <v-tooltip
            top
            v-bind:key="header.type.key"
            v-if="header.type.key === 'Year'"
          >
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <no-autocomplete-textfield
                  style="min-width: 200px"
                  label=" "
                  :value="item.Year"
                  @input="updateYear($event, item)"
                  :rules="[$rules.year]"
                  class="required"
                ></no-autocomplete-textfield>
              </div>
            </template>
            <span class="previous-value-tooltip">
              {{ $t("components.memberimportsalaries.previous_value") }}
              <b>{{ displayOriginalYear(item) }}</b>
            </span>
          </v-tooltip>
          <v-tooltip
            top
            v-bind:key="header.type.key"
            v-if="header.type.key === 'StartDate'"
          >
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <pbas-date-picker
                  style="margin:0 auto 15px"
                  label=" "
                  :value="item.StartDate"
                  @update-date="updateStartDate($event, item)"
                  :rules="[
                    $rules.required,
                    (val) => rules.startDate(val, item),
                  ]"
                  class="required"
                  :allowedDates="(val) => allowedStartDates(val, item)"
                />
              </div>
            </template>
            <span class="previous-value-tooltip">
              {{ $t("components.memberimportsalaries.previous_value") }}
              <b>{{ displayOriginalStartDate(item) }}</b>
            </span>
          </v-tooltip>
          <v-tooltip
            top
            v-bind:key="header.type.key"
            v-if="header.type.key === 'EndDate'"
          >
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <pbas-date-picker
                  style="margin:0 auto 15px"
                  label=" "
                  :value="item.EndDate"
                  @update-date="updateEndDate($event, item)"
                  :rules="[$rules.required, (val) => rules.endDate(val, item)]"
                  class="required"
                  :allowedDates="(val) => allowedEndDates(val, item)"
                />
              </div>
            </template>
            <span class="previous-value-tooltip">
              {{ $t("components.memberimportsalaries.previous_value") }}
              <b>{{ displayOriginalEndDate(item) }}</b>
            </span>
          </v-tooltip>
          <div
            v-bind:key="header.type.key"
            v-if="header.type.key === 'IsCompleted'"
            style="margin:0 auto 15px;!important"
          >
            <v-checkbox v-model="item.IsCompleted" :disabled="true" />
          </div>
          <v-tooltip
            top
            v-bind:key="header.type.key"
            v-if="header.type.key === 'CalendarMonth'"
          >
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-autocomplete
                  style="min-width: 200px"
                  label=" "
                  :value="item.CalendarMonth"
                  @change="updateCalendarMonth($event, item)"
                  :rules="[$rules.requiredInteger]"
                  class="required"
                  :items="$helpers.months()"
                ></v-autocomplete>
              </div>
            </template>
            <span class="previous-value-tooltip">
              {{ $t("components.memberimportsalaries.previous_value") }}
              <b>{{ displayOriginalCalendarMonth(item) }}</b>
            </span>
          </v-tooltip>
          <v-tooltip
            top
            v-bind:key="header.type.key"
            v-if="header.type.key === 'CalendarYear'"
          >
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <no-autocomplete-textfield
                  style="min-width: 200px"
                  label=" "
                  :value="item.CalendarYear"
                  @input="updateCalendarYear($event, item)"
                  :rules="[$rules.year]"
                  class="required"
                  :ref="`calendarYear${item.Identifier}`"
                ></no-autocomplete-textfield>
              </div>
            </template>
            <span class="previous-value-tooltip">
              {{ $t("components.memberimportsalaries.previous_value") }}
              <b>{{ displayOriginalCalendarYear(item) }}</b>
            </span>
          </v-tooltip>
        </template>
      </pbas-data-table>
    </v-card-text>
    <error-handler :error="error"></error-handler>
    <v-dialog scrollable v-model="warningDialog" persistent max-width="800">
      <material-card
        :title="$t('components.memberimportsalaries.warning_title')"
        icon="warning"
        :color="$vuetify.theme.themes.light.warning"
      >
        <v-card-text>
          {{ $t("components.memberimportsalaries.warning_text") }}
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="itemsChangeWarningNo">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="primary" @click="itemsChangeWarningYesDiscard">
            {{ $t("components.memberimportsalaries.discard_changes") }}
          </v-btn>
          <v-btn color="primary" @click="itemsChangeWarningYesSave">
            {{ $t("components.memberimportsalaries.save_changes") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="locking" persistent max-width="200">
      <v-card>
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog scrollable v-model="dialogs.add" persistent max-width="800">
      <term-add
        :dialog="dialogs.add"
        @close="dialogs.add = false"
        @save="addTerm"
      />
    </v-dialog>
    <v-snackbar v-model="snackbar" color="success" timeout="2500">
      {{ $t("components.contrinutionstermssetuptable.saved") }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../../components/ErrorHandler";
import { ODataProvider } from "pbas-vue-components";
import { locker } from "../../mixins/locker";
import { planSetter } from "../../mixins/planSetter";
import PreviousValueTooltipTransTextbox from "../../components/PreviousValueTooltipTransTextbox";
import ContributionTermsHeaders from "../../headers/ContributionTerms";
import TermAdd from "./TermAdd";
import NoAutocompleteTextfield from "../NoAutocompleteTextfield.vue";
import TransTextbox from "../TransTextbox.vue";

export default {
  name: "contribution-terms-setup-table",
  components: {
    ErrorHandler,
    PreviousValueTooltipTransTextbox,
    TermAdd,
    NoAutocompleteTextfield,
    TransTextbox,
  },
  mixins: [locker, planSetter],
  props: ["employer"],
  data() {
    return {
      rules: {
        startDate: (v, item) => {
          if (v === undefined || v === null || v === "") {
            return true;
          }
          if (
            this.planIdentity === null ||
            this.planIdentity === undefined ||
            this.planIdentity.FirstRenewalDate === null ||
            this.planIdentity.FirstRenewalDate === undefined
          ) {
            return true;
          }
          const n = Date.parse(this.planIdentity.FirstRenewalDate);
          const d = new Date(n);
          if (!this.isDate(v)) {
            return this.$t("validation.date_{0}", [
              this.formatValidationDate(d),
            ]);
          }
          const val = new Date(Date.parse(v));
          return (
            val >= d ||
            this.$t("validation.date_{0}", [this.formatValidationDate(d)])
          );
        },
        endDate: (v, item) => {
          if (v === undefined || v === null || v === "") {
            return true;
          }
          if (
            item === null ||
            item === undefined ||
            item.StartDate === null ||
            item.StartDate === undefined
          ) {
            return true;
          }
          const n = Date.parse(item.StartDate);
          const d = new Date(n);
          if (!this.isDate(v)) {
            return this.$t("validation.date_{0}", [
              this.formatValidationDate(d),
            ]);
          }
          const val = new Date(Date.parse(v));
          return (
            val >= d ||
            this.$t("validation.date_{0}", [this.formatValidationDate(d)])
          );
        },
      },
      show: true,
      locking: false,
      discardDisabled: true,
      warningOptions: {},
      warningDialog: false,
      saveDisabled: true,
      originalData: [],
      error: null,
      provider: undefined,
      headers: [],
      term: null,
      rowActions: [
        {
          title: "globals.delete",
          name: "delete",
          icon: "delete",
          handler: (item) => {
            // console.log(item);
            // await this.deleteContributionTermSetupItem({
            //   planIdentityId: this.selectedPlan.Id,
            //   id: item.Id
            // })
            if (item.Identifier === null || item.Identifier === undefined) {
              this.$refs.table.fetchResult.items = this.$refs.table.fetchResult.items.filter(
                (o) => o.Id !== item.Id
              );
              this.deletedRows.push(item);
            } else {
              this.$refs.table.fetchResult.items = this.$refs.table.fetchResult.items.filter(
                (o) => o.Identifier !== item.Identifier
              );
            }
            this.setSaveDisabled(true);
          },
        },
      ],
      dialogs: {
        add: false,
      },
      loading: false,
      updateMonitor: null,
      snackbar: false,
      deletedRows: [],
      saving: false,
    };
  },
  computed: {
    ...mapGetters("common", ["language", "languages"]),
    ...mapGetters("common", {
      selectedPlan: "plan",
    }),
    ...mapGetters("plansMembers", {
      columnsDropDownOptions: "options",
      planColumnsOptions: "planOptions",
      planIdentity: "planIdentity",
    }),
    floatActions() {
      console.log("floatActions:", this.saveDisabled, this.discardDisabled);
      if (this.saveDisabled && this.discardDisabled) {
        return [
          {
            text: "globals.add",
            color: this.$vuetify.theme.themes.light.success,
            name: "add",
            icon: "add",
            handler: async () => {
              // this.term = {};
              // this.dialogs.add = true;
              this.saveDisabled = true;
              this.loading = true;
              try {
                const lastTerms = (await this.getLastTerm({
                  planIdentityId: this.selectedPlan.Id,
                  employerId: this.employer.Id,
                })).data.value;
                let lastTerm = lastTerms.length > 0 ? lastTerms[0] : undefined;
                const localLastTerm = this.getLocalLastTerm();
                if (lastTerm === undefined) {
                  lastTerm = localLastTerm;
                } else if (localLastTerm !== undefined) {
                  if (
                    Date.parse(lastTerm.EndDate) <
                    Date.parse(localLastTerm.EndDate)
                  ) {
                    lastTerm = localLastTerm;
                  }
                }
                const nextEndDate = this.nextEndDate(lastTerm);
                this.addTerm({
                  Identifier: Math.random(),
                  modified: true,
                  valid: false,
                  StartDate: this.nextStartDate(lastTerm),
                  EndDate: nextEndDate,
                  Year:
                    nextEndDate !== null && nextEndDate !== undefined
                      ? nextEndDate.split("-")[0]
                      : undefined,
                });
              } catch (error) {
                this.error = error;
              } finally {
                this.loading = false;
              }
            },
          },
        ];
      }
      return [];
    },
  },
  watch: {
    selectedPlan: {
      handler() {
        this.provider = undefined;
        if (this.employer !== null && this.employer !== undefined) {
          this.$nextTick(() => {
            this.loadPlanData();
          });
        }
      },
    },
    employer: {
      handler() {
        this.provider = undefined;
        if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
          this.$nextTick(() => {
            this.loadPlanData();
          });
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.headers = ContributionTermsHeaders.filter(
      (o) => o.title !== "headers.contributionterms.completed"
    );
    if (
      this.selectedPlan !== null &&
      this.selectedPlan !== undefined &&
      this.employer !== null &&
      this.employer !== undefined
    ) {
      this.loadPlanData();
    }
  },
  methods: {
    ...mapActions("plansMembers", [
      "bulkUpdateContributionTerms",
      "getLastTerm",
    ]),
    getLocalLastTerm() {
      if (
        this.$refs.table &&
        this.$refs.table.fetchResult &&
        this.$refs.table.fetchResult.items &&
        this.$refs.table.fetchResult.items.length > 0
      ) {
        const ordered = this.$refs.table.fetchResult.items.sort((a, b) =>
          Date.parse(a.EndDate) > Date.parse(b.EndDate) ? -1 : 1
        );
        return ordered[0];
      } else {
        return undefined;
      }
    },
    nextStartDate(term) {
      // console.log("next start date: ", term);
      if (term === null || term === undefined) {
        // console.log(this.planIdentity)
        return this.planIdentity.FirstRenewalDate;
      }
      const lastEndDateString = term.EndDate;

      const lastEndDate = Date.parse(lastEndDateString);
      let newStartDate = new Date(lastEndDate);
      newStartDate.setUTCDate(newStartDate.getUTCDate() + 1);
      return this.formatDate2(newStartDate);
    },
    nextEndDate(term) {
      if (term === null || term === undefined) {
        return undefined;
      }
      const lastStartDateString = term.StartDate;
      const lastEndDateString = term.EndDate;

      const lastStartDate = new Date(lastStartDateString.split("T")[0]);
      const lastEndDate = new Date(lastEndDateString.split("T")[0]);
      const diffTime = Math.abs(lastEndDate - lastStartDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      let newEndDate = new Date(lastEndDate);
      newEndDate.setUTCDate(newEndDate.getUTCDate() + 1 + diffDays);
      return this.formatDate2(newEndDate);
    },
    formatDate2(d) {
      let month = (d.getUTCMonth() + 1).toString();
      if (month.length === 1) {
        month = "0" + month;
      }
      let day = d.getUTCDate().toString();
      if (day.length === 1) {
        day = "0" + day;
      }
      return `${d.getUTCFullYear()}-${month}-${day}T00:00:00.000Z`;
    },
    addTerm(item) {
      this.originalData.unshift(item);
      this.$refs.table.fetchResult.count++;
      this.$refs.table.fetchResult.items.unshift(item);
      this.dialogs.add = false;
      this.setSaveDisabled();
      return;
    },
    async loadPlanData() {
      const url = `plans/${this.selectedPlan.Id}/employers-for-import/${
        this.employer.Id
      }/contribution-terms`;
      this.provider = new ODataProvider(this.$axiosHttp, url, this.headers);
    },
    isDate(val) {
      if (
        new RegExp(/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/).test(
          val
        )
      ) {
        return !isNaN(Date.parse(val));
      }
      return false;
    },
    formatValidationDate(d) {
      let month = (d.getUTCMonth() + 1).toString();
      if (month.length === 1) {
        month = "0" + month;
      }
      let day = d.getUTCDate().toString();
      if (day.length === 1) {
        day = "0" + day;
      }
      return `${d.getUTCFullYear()}-${month}-${day}`;
    },
    allowedStartDates(val, item) {
      const n = Date.parse(val);
      const d = new Date(n);
      let n2 = Date.parse(this.planIdentity.FirstRenewalDate);
      const d2 = new Date(n2);
      return d >= d2;
    },
    allowedEndDates(val, item) {
      const n = Date.parse(val);
      const d = new Date(n);
      let n2 = Date.parse(item.StartDate);
      const d2 = new Date(n2);
      return d >= d2;
    },
    formatDate(dateString) {
      if (dateString === undefined || dateString === null) {
        return "";
      }
      const [date, time] = dateString.split("T");
      const [year, month, day] = date.split("-");
      return `${year}-${month}-${day}`;
    },
    displayOriginalStartDate(item) {
      if (item.Id !== null && item.Id !== undefined) {
        return this.formatDate(
          this.originalData.filter((o) => o.Id === item.Id)[0].StartDate
        );
      }
      return "";
    },
    displayOriginalEndDate(item) {
      if (item.Id !== null && item.Id !== undefined) {
        return this.formatDate(
          this.originalData.filter((o) => o.Id === item.Id)[0].EndDate
        );
      }
      return "";
    },
    displayOriginalName(item) {
      if (item.Id !== null && item.Id !== undefined) {
        return this.originalData.filter((o) => o.Id === item.Id)[0].Name;
      }
      return "";
    },
    displayOriginalYear(item) {
      if (item.Id !== null && item.Id !== undefined) {
        return this.originalData.filter((o) => o.Id === item.Id)[0].Year;
      }
      return "";
    },
    displayOriginalCalendarYear(item) {
      if (item.Id !== null && item.Id !== undefined) {
        return this.originalData.filter((o) => o.Id === item.Id)[0]
          .CalendarYear;
      }
      return "";
    },
    displayOriginalCalendarMonth(item) {
      if (item.Id !== null && item.Id !== undefined) {
        const month = this.originalData.filter((o) => o.Id === item.Id)[0]
          .CalendarMonth;
        return this.$helpers.months().filter((o) => o.value === month)[0].text;
      }
      return "";
    },
    async itemsChangeWarningNo() {
      this.$refs.table.itemsChangeWarningNo(this.warningOptions);
      this.warningDialog = false;
    },
    async itemsChangeWarningYesDiscard() {
      //await this.unlock();
      this.$refs.table.itemsChangeWarningYes(this.warningOptions);
      this.warningDialog = false;
    },
    async itemsChangeWarningYesSave() {
      await this.save();
      //await this.unlock();
      this.$refs.table.itemsChangeWarningYes(this.warningOptions);
      this.warningDialog = false;
    },
    async itemsChangeWarning(options) {
      const a = this.$refs.table.fetchResult.items.filter((o) => o.modified);
      // console.log(a);
      const changesExist = a.length > 0;
      if (changesExist) {
        this.warningOptions = options;
        this.warningDialog = true;
      } else {
        //await this.unlock();
        this.$refs.table.itemsChangeWarningYes(options);
      }
    },
    async setData(items) {
      // this.locking = true;
      this.originalData = JSON.parse(JSON.stringify(items));
      this.setSaveDisabled();
      // try {
      //   await this.lock(
      //     this.lockMassive,
      //     {
      //       planIdentityId: this.selectedPlan.Id,
      //       memberIdentityIds: items.map((o) => o.Id),
      //     },
      //     () => {
      //       this.$router.push({
      //         name: "members",
      //         params: { planId: this.selectedPlan.Id },
      //       });
      //     }
      //   );
      // } catch (error) {
      //   this.error = error;
      //   setTimeout(() => {
      //     this.$router.push({
      //       name: "members",
      //       params: { planId: this.selectedPlan.Id },
      //     });
      //   }, 1000);
      // } finally{
      //   this.locking = false;
      // }
    },
    itemSlotFunc(header) {
      return "item." + header.type.key;
    },
    isRowModified(row, original) {
      if (row.Identifier !== null && row.Identifier !== undefined) {
        return true;
      }
      const modified =
        row.Name !== original.Name ||
        row.Year !== original.Year ||
        row.CalendarMonth !== original.CalendarMonth ||
        row.CalendarYear !== original.CalendarYear ||
        this.fixDateFormat(row.StartDate) !== original.StartDate ||
        this.fixDateFormat(row.EndDate) !== original.EndDate;
      return modified;
    },
    fixDateFormat(dateString) {
      if (
        dateString === undefined ||
        dateString === null ||
        dateString === ""
      ) {
        return "";
      }
      const [date, time] = dateString.split("T");
      const [year, month, day] = date.split("-");
      return `${year}-${month}-${day}T00:00:00Z`;
    },
    isRowValid(row) {
      const valid =
        row.Name !== null &&
        row.Name !== undefined &&
        this.$rules.numericString(row.Name) === true &&
        this.$rules.dynamic.length(2)(row.Name) === true &&
        row.Year !== null &&
        row.Year !== undefined &&
        this.$rules.year(row.Year) === true &&
        row.StartDate !== null &&
        row.StartDate !== undefined &&
        row.StartDate !== "" &&
        row.EndDate !== null &&
        row.EndDate !== undefined &&
        row.EndDate !== "" &&
        row.CalendarMonth !== null &&
        row.CalendarMonth !== undefined &&
        row.CalendarYear !== null &&
        row.CalendarYear !== undefined &&
        this.$rules.year(row.CalendarYear) === true;
      return valid;
    },
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async updateField(value, row, field) {
      const obj = {};
      this.updateMonitor = obj;
      await this.delay(800);
      if (this.updateMonitor !== obj) {
        return;
      }
      this.onUpdateField(value, row, field);
    },
    async onUpdateField(value, row, field) {
      // const obj = {};
      // this.updateMonitor = obj;
      // await this.delay(800);
      // if (this.updateMonitor !== obj) {
      //   return;
      // }
      if (value === null || value === undefined || value === "") {
        value = undefined;
      }
      row[field] = value;
      if (field === "EndDate") {
        if (value !== undefined) {
          if (row.Year === null || row.Year === undefined || row.Year === "") {
            row.Year = value.split("-")[0];
          }
        }
      }
      const original =
        row.Id !== null && row.Id !== undefined
          ? this.originalData.filter((o) => o.Id === row.Id)[0]
          : this.originalData.filter((o) => o.Identifier === row.Identifier)[0];
      row.modified = this.isRowModified(row, original);
      row.valid = this.isRowValid(row);
      this.setSaveDisabled(value, field);
    },
    updateName(value, row) {
      // console.log(value, row);
      // row.Name = value;
      // const original =
      //   row.Id !== null && row.Id !== undefined
      //     ? this.originalData.filter((o) => o.Id === row.Id)[0]
      //     : this.originalData.filter((o) => o.Identifier === row.Identifier)[0];
      // row.modified = this.isRowModified(row, original);
      // row.valid = this.isRowValid(row);
      // this.setSaveDisabled();
      this.updateField(value, row, "Name");
    },
    updateYear(value, row) {
      // if (value === null || value === undefined) {
      //   return;
      // }
      // row.Year = value;
      // const original =
      //   row.Id !== null && row.Id !== undefined
      //     ? this.originalData.filter((o) => o.Id === row.Id)[0]
      //     : this.originalData.filter((o) => o.Identifier === row.Identifier)[0];
      // row.modified = this.isRowModified(row, original);
      // row.valid = this.isRowValid(row);
      // this.setSaveDisabled();
      this.updateField(value, row, "Year");
    },
    updateCalendarYear(value, row) {
      this.updateField(value, row, "CalendarYear");
    },
    updateCalendarMonth(value, row) {
      this.updateField(value, row, "CalendarMonth");
    },
    updateStartDate(value, row) {
      // console.log("update start date: ", value, row);
      // if (value === null || value === undefined) {
      //   return;
      // }
      // row.StartDate = value;
      // const original =
      //   row.Id !== null && row.Id !== undefined
      //     ? this.originalData.filter((o) => o.Id === row.Id)[0]
      //     : this.originalData.filter((o) => o.Identifier === row.Identifier)[0];
      // row.modified = this.isRowModified(row, original);
      // row.valid = this.isRowValid(row);
      // this.setSaveDisabled();
      this.updateField(value, row, "StartDate");
    },
    updateEndDate(value, row) {
      // if (value === null || value === undefined) {
      //   return;
      // }
      // row.EndDate = value;
      // row.Year = value.split("-")[0];
      // const original =
      //   row.Id !== null && row.Id !== undefined
      //     ? this.originalData.filter((o) => o.Id === row.Id)[0]
      //     : this.originalData.filter((o) => o.Identifier === row.Identifier)[0];
      // row.modified = this.isRowModified(row, original);
      // row.valid = this.isRowValid(row);
      // this.setSaveDisabled();
      this.updateField(value, row, "EndDate");
    },
    setSaveDisabled(v, f) {
      if (
        this.$refs.table === null ||
        this.$refs.table === undefined ||
        this.$refs.table.fetchResult === null ||
        this.$refs.table.fetchResult === undefined
      ) {
        this.saveDisabled = true;
        this.discardDisabled = true;
        return;
      }
      // let deleted = [];
      // for (let item of this.originalData) {
      //   if (
      //     this.$refs.table.fetchResult.items.filter((o) => o.Id === item.Id)
      //       .length === 0
      //   ) {
      //     deleted.push(item);
      //   }
      // }
      this.saveDisabled =
        (this.$refs.table.fetchResult.items.filter((o) => o.modified && o.valid)
          .length === 0 ||
          this.$refs.table.fetchResult.items.filter(
            (o) => o.modified && !o.valid
          ).length > 0) &&
        this.deletedRows.length === 0; //the deleted ones;
      this.discardDisabled =
        this.$refs.table.fetchResult.items.filter((o) => o.modified).length ===
          0 && this.deletedRows.length === 0;
      this.$emit("save-disabled", {
        saveDisabled: this.saveDisabled,
        discardDisabled: this.discardDisabled,
      });
      if (this.saveDisabled !== true) {
        this.save();
      }
      return;
    },
    async save() {
      this.saving = true;
      this.$refs.table.onFloatActionsChanged(this.floatActions);
      try {
        let items = JSON.parse(
          JSON.stringify(
            this.$refs.table.fetchResult.items.filter(
              (o) => o.IsCompleted !== true && o.modified && o.valid
            )
          )
        );
        for (let item of items) {
          item.EmployerId = this.employer.Id;
          item.PlanId = this.selectedPlan.Id;
          delete item.modified;
          delete item.valid;
          delete item.Identifier;
          for (let lang of this.languages) {
            if (item.Translations === null || item.Translations === undefined) {
              item.Translations = [];
            }
            let trans = item.Translations.filter(
              (o) => o.LanguageCode === lang.language
            );
            if (trans.length === 0) {
              item.Translations.push({
                LanguageCode: lang.language,
                Name: item.Name,
                Year: item.Year,
              });
            } else {
              const index = item.Translations.indexOf(trans[0]);
              item.Translations[index].Name = item.Name;
              item.Translations[index].Year = item.Year;
            }
          }
        }
        await this.bulkUpdateContributionTerms({
          planIdentityId: this.selectedPlan.Id,
          employerId: this.employer.Id,
          payload: {
            ContributionTerms: items,
          },
        });
        //await this.unlock();
        this.$refs.table.getDataAsync();
        
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
        // this.$refs.table.onFloatActionsChanged(this.floatActions);
        this.snackbar = true;
      }
    },
    async discard() {
      // if (this.$refs)
      //await this.unlock();
      this.deletedRows = [];
      await this.$refs.table.getDataAsync();
      this.setSaveDisabled();
    },
  },
};
</script>
<style>
.previous-value-tooltip {
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  margin-bottom: 10px;
}
.v-tooltip__content {
  background-color: orange;
  max-width: fit-content !important;
  width: fit-content !important;
}
</style>
